import React, { useRef } from 'react';
import Radio from '@material-ui/core/Radio';
import { useStyles } from './RadioContainer.style';
import Typography from '@material-ui/core/Typography';
export const RadioContainer = (props) => {
    var _a;
    const { heading, description, name, value } = props;
    const classes = useStyles(props);
    const inputRef = useRef(null);
    return (React.createElement("label", { className: `${classes.container} ${((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.checked) ? classes.checked : classes.default}`, "data-qa": "radio-container" },
        React.createElement(Radio, { name: name, value: value, inputRef: inputRef }),
        React.createElement("div", { className: classes.text_container },
            React.createElement(Typography, { className: classes.heading }, heading),
            React.createElement(Typography, { className: classes.description }, description))));
};
